module.exports = __webpack_public_path__ + "img/CR08EU.ee502900.png";